import $ from 'jquery';
import IdGenerator from 'fg-frontend/idGenerator';

export default class Component {
  constructor(props) {
    this.setProps($.extend({}, this.getDefaultProps(), props || {}));
    this.setState(this.getInitialState());
  }

  /**
   *
   * @return {Object}
   */
  getDefaultProps() {
    return {};
  }

  /**
   *
   * @return {Object}
   */
  getInitialState() {
    return {
      inDocument: false
    };
  }
  setState(state) {
    this.state = $.extend({}, this.state, state);
    this.update();
  }
  setProps(props) {
    this.props = $.extend({}, this.props, props);
    this.update();
  }
  decorate(element) {
    this.element = (element instanceof jQuery) ? element : $(element);
    const callback = function() {
      this.decorateInternal(this.element);
      this.enterDocument();
      $(this).trigger('readytouse');
    };
    /*
     if (this.props.asyncScript) {
     const loader = ScriptLoader.getInstance();
     loader.load(this.this.props.asyncScript);
     loader.addLoadCallback(this.props.asyncScript.name, $.proxy(callback, this));
     } else {
     */
    callback.call(this);
    //}
    this.element.addClass('is-decorated');
    this.element.data('decoratorInstance', this);
    this.element.attr('data-decorator-component-name', this.constructor.COMPONENT_NAME);
  }
  decorateInternal(element) {

  }
  enterDocument() {
    this.setState({inDocument: true});
  }
  updateInternal() {

  }
  /**
   * @param {(string|Object.<string,*>)} eventType
   * @param {*=} selector
   * @param {function(!jQuery.event=)=} opt_handler
   */
  on(eventType, selector, opt_handler) {
    if (typeof selector == 'string') {
      this.element.on(eventType, selector, $.proxy(function(e) {
        opt_handler.call(this, e);
      }, this));
    }
    else {
      this.element.on(eventType, $.proxy(function(e) {
        selector.call(this, e);
      }, this));
    }
  }
  trigger(eventObject) {
    if (this.element) {
      this.element.trigger(eventObject);
    }
    $(this).trigger(eventObject);
  }
  update() {
    if (this.element && this.state.inDocument) {
      this.updateInternal();
    }
  }
  exitDocument() {
    if (this.element) {
      this.element.removeClass('is-decorated');
      this.element.removeData('decoratorInstance');
      this.element.removeAttr('data-decorator-component-name');
    }
  }
  /**
   *
   * @return {string}
   */
  getId() {
    if (!this.id_) {
      this.id_ = IdGenerator.getInstance().getNextUniqueId();
    }
    return this.id_;
  }
  setId(id) {
    this.id_ = id;
  }
  disposeInternal() {
    if (this.element) {
      this.element.off();
    }
    this.element = null;
    this.state = null;
    this.props = null;
  }
  dispose() {
    this.exitDocument();
    this.disposeInternal();
    $(this).off();
  }
}






// WEBPACK FOOTER //
// ./fe/web-career/src/js/web/MultipleWidgetContainer/Component.js